import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const PRO_FIELDS = [
  ["titulo", "Título", "Dra. / Dr. / Dre."],
  ["especialidad", "Especialidad", "Médica Cirujana/Esp. Salud Trans"],
  ["cedula", "Cédula profesional", ""],
  ["universidad", "Universidad", "Univ. La Salle"],
  ["telefono", "Teléfono", ""],
  ["direccion", "Dirección del consultorio", ""],
];

/** Campos del perfil profesional (aparecen en el encabezado de las recetas). */
export function ProfessionalFields({ form, onChange, showPaymentLink }) {
  const set = (k) => (e) => onChange({ ...form, [k]: e.target.value });
  return (
    <>
      {PRO_FIELDS.map(([key, label, ph]) => (
        <div key={key} className="space-y-1.5">
          <Label>{label}</Label>
          <Input value={form[key] || ""} onChange={set(key)} placeholder={ph} data-testid={`profile-${key}-input`} />
        </div>
      ))}
      {showPaymentLink && (
        <div className="space-y-1.5 col-span-2">
          <Label>Liga de pago de Stripe</Label>
          <Input
            value={form.payment_link || ""}
            onChange={set("payment_link")}
            placeholder="https://buy.stripe.com/..."
            data-testid="profile-payment-link-input"
          />
          <p className="text-xs text-muted-foreground">
            Tus pacientes pagarán la consulta con esta liga antes de enviarte su solicitud.
          </p>
        </div>
      )}
    </>
  );
}
